import React, { useState } from "react";
import { Box } from "@mui/material";
import DatosNav from "../components/DatosNav";
import PeriodFilters from "../components/PeriodFilters";
import ClientesDatosContainer from "./ClientesDatosContainer";
import EmbudoDatosContainer from "./EmbudoDatosContainer";
import GeneralDatosContainer from "./GeneralDatosContainer";
import VentasDatosContainer from "./VentasDatosContainer";
import VendedoresDatosContainer from "./VendedoresDatosContainer";
import VehiculosDatosContainer from "./VehiculosDatosContainer";
import { colors } from "../utils/datosTheme";
import { getPresetRange } from "../utils/datosPeriods";

export default function DatosContainer() {
  const initialRange = getPresetRange("last3");
  const [activeSection, setActiveSection] = useState("General");
  const [preset, setPreset] = useState("last3");
  const [desde, setDesde] = useState(initialRange.desde);
  const [hasta, setHasta] = useState(initialRange.hasta);
  const [showQuickFiltersInNav, setShowQuickFiltersInNav] = useState(false);

  const handlePresetChange = (next) => {
    if (!next) return;
    setPreset(next);
    if (next !== "custom") {
      const range = getPresetRange(next);
      setDesde(range.desde);
      setHasta(range.hasta);
    }
  };

  const handleScroll = (ev) => {
    const shouldShow = ev.currentTarget.scrollTop > 24;
    setShowQuickFiltersInNav((current) => current === shouldShow ? current : shouldShow);
  };

  return (
    <Box
      onScroll={handleScroll}
      sx={{
        height: "100%",
        overflow: "auto",
        color: colors.ink,
        background: "linear-gradient(180deg, rgba(246,248,252,0.96) 0%, rgba(255,255,255,0.92) 100%)",
      }}
    >
      <DatosNav
        active={activeSection}
        onChange={setActiveSection}
        showQuickFilters={showQuickFiltersInNav}
        preset={preset}
        onPresetChange={handlePresetChange}
      />

      <Box sx={{ width: "100%", maxWidth: "90vw", mx: "auto", px: { xs: 1.5, sm: 2.5, lg: 3 }, pb: 3 }}>
        <PeriodFilters
          preset={preset}
          onPresetChange={handlePresetChange}
          desde={desde}
          hasta={hasta}
          setDesde={setDesde}
          setHasta={setHasta}
          showQuickButtons={!showQuickFiltersInNav}
        />

        {activeSection === "General" ? (
          <GeneralDatosContainer desde={desde} hasta={hasta} />
        ) : activeSection === "Ventas" ? (
          <VentasDatosContainer desde={desde} hasta={hasta} />
        ) : activeSection === "Clientes" ? (
          <ClientesDatosContainer desde={desde} hasta={hasta} />
        ) : activeSection === "Vendedores" ? (
          <VendedoresDatosContainer desde={desde} hasta={hasta} />
        ) : activeSection === "Vehículos" ? (
          <VehiculosDatosContainer desde={desde} hasta={hasta} />
        ) : activeSection === "Embudo" ? (
          <EmbudoDatosContainer desde={desde} hasta={hasta} />
        ) : (
          null
        )}
      </Box>
    </Box>
  );
}
